export default __webpack_public_path__ + "static/media/element_spec_14.54842a6e.webp";